import { useScaffold } from "@Light/scaffold";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";

export type DocumentsSelectorLinkProps = {
  to: string;
  children: React.ReactNode;
};

export const DocumentsSelectorLink: React.FC<DocumentsSelectorLinkProps> = ({
  to,
  children,
}) => {
  const scaffold = useScaffold();
  const Link = scaffold.system.link;
  return (
    <Link
      to={to}
      className="w-full border-b py-6 flex justify-between items-center"
    >
      <div className="flex flex-col gap-2">{children}</div>
      <ChevronRightIcon
        className={clsx(
          "h-5 w-5 font-medium stroke-2",
          scaffold.page.colors.text.secondary,
        )}
      />
    </Link>
  );
};
